<form [formGroup]="form" novalidate class="form-group">
  <div class="row">
    <div class="col-12 col-md-4">
      <app-lfsa-input [control]="idPromoField" [id]="'id_promo'"
        [label]="'ID PROMO'" formControlName="idPromo" type="text"></app-lfsa-input>
      <div class="letrasDanger" *ngIf="idPromoField.hasError('existePromocion')"><small>Promoción ya existe</small></div>
    </div>
    <div class="col-6 col-lg-4 col-xl-3 mb-3">
      <label for="startDate" class="form-label">Fecha inicio</label>
      <div class="input-group input-group-sm">
        <input id="startDate" class="form-control" type="date" formControlName="fechaInicio" />
      </div>
    </div>
    <div class="col-6 col-lg-4 col-xl-3 mb-3">
      <fieldset>
        <label for="endDate" class="form-label">Fecha fin</label>
        <div class="input-group input-group-sm">
          <input id="endDate" class="form-control" [ngClass]="{'is-invalid': form.hasError('invalid_date')}" type="date" formControlName="fechaFin" />
          <div class="invalid-feedback" *ngIf="form.hasError('invalid_date')">
            Fecha debe ser despues de {{startDateField.value}}.
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</form>
<div class="row mt-3">
  <div class="form-group col-12">
    <app-lfsa-botones-formulario [loading]="false" [formularioValido]="form.invalid || idPromoField.pending"
      (devolverAccion)="acciones($event)" textBoton="Aceptar"></app-lfsa-botones-formulario>
  </div>
</div>
